export default __webpack_public_path__ + "static/media/cerrado.21f559c5.png";